<template>
  <div class="category-list">
    <CategoryListItem
        v-for="category in categories"
        :category="category"
        :key="category.CODFAVORITO"
        @CategorySelected="onCategorySelected"
    />
  </div>
</template>
<style lang="scss">
.category-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.4rem;
  grid-auto-rows: minmax(6.8rem, auto);

  @media screen and (max-width: 340px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &__item {
    align-items: flex-end;
    background-color: white;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    user-select: none !important;
    padding: 0.4rem;
    text-align: center;
    position: relative;
    line-height: 0.8rem;

    &__description {
      border-radius: 0 0 0.4rem 0.4rem;
      font-size: 0.8rem;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
}
</style>
<script>
import CategoryListItem from './CategoryListItem'

export default {
  components: { CategoryListItem },
  props: { categories: Array, default: [] },
  methods: {
    onCategorySelected(category) {
      this.$emit('CategorySelected', category)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Categories/CategoryList.vue